import { FILE_ALLOWED_EXTENSIONS } from 'common/constants';

import setConfigCsvImportModal from './setConfigCsvImportModal';
import uploadXML from './uploadXML';

export default ({ files, getValues, project }) =>
    (dispatch) => {
        if (!files?.length || !project) return;
        const [file] = files;
        const fileType = file?.type;
        if (FILE_ALLOWED_EXTENSIONS.CSV.includes(fileType))
            dispatch(setConfigCsvImportModal({ file, isOpen: true }));
        else if (FILE_ALLOWED_EXTENSIONS.XML.includes(fileType))
            dispatch(uploadXML({ file, getValues }));
    };
